export const playstoreUrl =
  'https://play.google.com/store/apps/details?id=com.asapuu.androidv2';
export const applestoreUrl = 'https://apps.apple.com/app/asapuu/id6738297970';

export const eventsUrl =
  process.env.REACT_APP_EVENTS_URL || 'https://events-staging.asapuu.com';
